import store from "./../store";
import router from "./../router";
import DashboardAPI from "./../api/dashboard";


export const formatarValorMonetario = valor => {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
    }).format(valor);
};

export const formatarValor = valor => {
    return new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        maxDigits: 4
    }).format(valor);
};

export const formatarValorPercent = valor => {
    return new Intl.NumberFormat("pt-BR", {
        style: "percent",
        maxDigits: 2
    }).format(valor);
};

export const exibirMensagem = (mensagem, color, timeout) => {
    const snackbar = { mensagem, color, timeout, ativo: true };
    store.dispatch("snackbar/habilitarSnackBar", snackbar);
};

export const verificarToken = () => {
    if (!localStorage.getItem("token")) router.push({ name: "Home" });

    const headers = iniciarRequisicao();

    DashboardAPI.getValidateUser(headers)
        .then(response => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            let hash = localStorage.getItem("hash_acesso");
            let user = response.data.user;

            atualizarFlagsParceria(response.data.parceria);

            if (hash != user.hash_acesso) {
                alert(
                    "A licença do usuário já esta sendo utilizada em outro dispositivo."
                );
                router.push({ name: "Home" });
            }
        })
        .catch(() => {
            logout();
        });
};

export const atualizarFlagsParceria = (parceria) => {
    if (parceria && parceria.ativa) {
        localStorage.setItem("parceira_ativa", "1");
        localStorage.setItem("parceira_nome", parceria.parceira_nome || "");
    } else {
        localStorage.setItem("parceira_ativa", "0");
        localStorage.setItem(
            "parceira_nome",
            (parceria && parceria.parceira_nome) || ""
        );
    }
};

export const logout = () => {
    const itens = [
        "token",
        "nome",
        "service",
        "setor",
        "hash_acesso",
        "urls",
        "empresa",
        "id",
        "filial_compra",
        "fator_atuacao",
        "equipe",
        "controle",
        "parceira_ativa",
        "parceira_nome"
    ];

    itens.forEach(item => {
        localStorage.removeItem(item);
    });

    router.push({ name: "Home" });
};

export const getHeaderRequisicao = () => {

    const token = localStorage.getItem("token");

    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    };

    store.dispatch("loading/habilitarLoading", false);

    return headers;
};



export const iniciarRequisicao = () => {


    const token = localStorage.getItem("token");

    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    };

    store.dispatch("loading/habilitarLoading", true);

    return headers;
};

export function validarCPF(cpf) {
    const digits = String(cpf || '').replace(/[^0-9]/g, '');
    if (digits.length !== 11 || /^(\d)\1+$/.test(digits)) return false;
    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(digits[i]) * (10 - i);
    let r1 = (soma * 10) % 11;
    if (r1 === 10 || r1 === 11) r1 = 0;
    if (r1 !== parseInt(digits[9])) return false;
    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(digits[i]) * (11 - i);
    let r2 = (soma * 10) % 11;
    if (r2 === 10 || r2 === 11) r2 = 0;
    return r2 === parseInt(digits[10]);
}

// Titulo eleitoral: 12 digitos (8 sequenciais + 2 da UF + 2 verificadores).
// Algoritmo do TSE, com a excecao SP (UF 01) / MG (UF 02).
export function validarTituloEleitoral(titulo) {
    const d = String(titulo || '').replace(/[^0-9]/g, '');
    if (d.length !== 12 || /^(\d)\1+$/.test(d)) return false;
    const uf = d.slice(8, 10);
    const ehSpMg = uf === '01' || uf === '02';
    let s1 = 0;
    for (let i = 0; i < 8; i++) s1 += parseInt(d[i], 10) * (i + 2);
    const r1 = s1 % 11;
    const dv1 = r1 === 0 ? (ehSpMg ? 1 : 0) : (r1 === 10 ? 0 : r1);
    if (dv1 !== parseInt(d[10], 10)) return false;
    const s2 = parseInt(d[8], 10) * 7 + parseInt(d[9], 10) * 8 + dv1 * 9;
    const r2 = s2 % 11;
    const dv2 = r2 === 0 ? (ehSpMg ? 1 : 0) : (r2 === 10 ? 0 : r2);
    return dv2 === parseInt(d[11], 10);
}